// Dependencies
import React, { Suspense, lazy } from 'react';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
    Navigate,
    Outlet
} from "react-router-dom";

// MSAL
import { MsalProvider, MsalContext } from "@azure/msal-react"

// Contexts
import { AppThemeProvider } from 'contexts/AppThemeProvider';
import { NotificationContextProvider } from 'contexts/NotificationContextProvider';

// Global Components
import { ErrorBoundary } from 'components/ErrorBoundary';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { PageLayout } from 'components/PageLayout';

// Services
// import { loggerService } from 'services/logger';

// Hooks
import { useNetwork } from 'hooks/useNetwork';

// Guards
import { RouteGuard } from 'components/RouteGuard';

// Styles
import 'styles/App.css';
// Optional City and Font Awesome icons
// import 'styles/cicon/style.css';
// import 'styles/font-awesome/style.css';

// Pages
const SignIn = lazy(() => import('pages/SignIn'));
const RoadsForm = lazy(() => import('pages/RoadsNotifications'));
const ThankYou = lazy(() => import('pages/ThankYou'));

const Pages = () => {
    useNetwork();

    // const { pathname } = useLocation();
    // loggerService.trackTrace(`*** Router switch: ${pathname}`);

    return (
        <PageLayout>
            <ErrorBoundary>
                <Suspense fallback={<LoadingIndicator />}>
                    <Outlet /> {/* This will render the nested routes defined in the router */}
                </Suspense>
            </ErrorBoundary>
        </PageLayout>
    );
};
const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<Pages />} errorElement={<ErrorBoundary />}>
            <Route path="/" element={<SignIn />} />
            <Route path="/notifications-form" element={<RouteGuard><RoadsForm /></RouteGuard>} />
            <Route path="/thank-you/:type" element={<RouteGuard><ThankYou /></RouteGuard>} />
            <Route path="*" element={<Navigate to='/' />} />
        </Route>
    )
);

const App = ({ instance }) => {
    return (
        <AppThemeProvider>
            <NotificationContextProvider>
                <MsalProvider instance={instance}>
                    <RouterProvider router={router} />
                </MsalProvider>
            </NotificationContextProvider>
        </AppThemeProvider>
    );
}

// make msalContext available to other components
App.msalContext = MsalContext;

export default App;